import { useCallback, useSyncExternalStore } from "react";

/** Favoritos do menu (atalhos na barra superior). Guardados por navegador e por área (pf/pj), como o layout do Início. */
const key = (realm: string) => `mm.favNav.${realm}`;
const listeners = new Set<() => void>();
const cache = new Map<string, string>();
const read = (realm: string): string => { try { return localStorage.getItem(key(realm)) ?? "[]"; } catch { return cache.get(realm) ?? "[]"; } };
const parse = (raw: string): string[] => { try { const v = JSON.parse(raw); return Array.isArray(v) ? v.filter((x) => typeof x === "string") : []; } catch { return []; } };
const write = (realm: string, list: string[]) => {
  const raw = JSON.stringify(list); cache.set(realm, raw);
  try { localStorage.setItem(key(realm), raw); } catch { /* sem armazenamento: vale só nesta sessão */ }
  listeners.forEach((l) => l());
};
const subscribe = (cb: () => void) => { listeners.add(cb); return () => { listeners.delete(cb); }; };

export function useFavorites(realm: string) {
  const raw = useSyncExternalStore(subscribe, () => read(realm), () => "[]");
  const list = parse(raw);
  const toggle = useCallback((to: string) => { const cur = parse(read(realm)); write(realm, cur.includes(to) ? cur.filter((x) => x !== to) : [...cur, to]); }, [realm]);
  return { list, has: (to: string) => list.includes(to), toggle };
}
